import * as types from "../types";

const initialState = {
  loader: false,
};

export default function loaders(
  state = initialState,
  { type, payload = false } 
) {
  switch (type) {
    case types.UPDATE_LOADER:
      //console.log("1",state);

      return {
        ...state,
        loader: payload,
      };

    
    
    default:
      return state;
  }
}
